import { hoverCards } from './hover-cards'
import { animateSvg } from './animateSvg'
import { autoNav } from './auto-nav'
import { scrollToTops } from './scroll-to-top'
import './animate'

document.addEventListener('DOMContentLoaded', () => {
  hoverCards()
  animateSvg()
  scrollToTops()
  autoNav()
})



// WEBPACK FOOTER //
// ./src/js/components/js-component/index.js